import React, { useEffect, useState } from "react";
import Container from "../../UI/Container";
import { Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from '@mui/styles';
import TurmaProfile from "../../Turma/TurmaProfile";
import PresencaTurmaTable from "./PresencaTurmaTable";
import { findByTdpTurmaCodigo, remove } from "../api-presenca";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import Loading from "../../UI/Loading";
import PresencaTurmaForm from "./PresencaTurmaForm";
import TurmaTableSelectView from "../../Turma/TurmaTableSelectView";
import { findByAnoLetivo } from "../../Turma/api-turma";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  paper: {
    padding: "20px",
  },
  title: {
    marginBottom: "20px",
  },
});

const PresencaTurmaContainer = () => {
  const classes = useStyles();
  const [turma, setTurma] = useState(null);
  const [presencas, setPresencas] = useState({
    content: [],
    size: 0,
    totalElements: 0,
    number: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingRemove, setIsLoadingRemove] = useState(false);
  const [presenca, setPresenca] = useState(null);

  const [turmas, setTurmas] = useState([]);
  const [isLoadingTurmas, setIsLoadingTurmas] = useState(false);

  useEffect(() => {
    setIsLoadingTurmas(true);
    findByAnoLetivo().then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setTurmas(data);
        }
      }
      setIsLoadingTurmas(false);
    });
  }, []);

  useEffect(() => {
    if (turma && turma.codigo) {
      setIsLoading(true);
      findByTdpTurmaCodigo(turma.codigo, 0).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPresencas(data);
          }
        }
        setIsLoading(false);
      });
    }
  }, [turma]);

  const handleTrocaTurma = () => {
    setTurma(null);
  };

  const handleChangePage = (event, newPage) => {
    if (turma && turma.codigo) {
      setIsLoading(true);
      findByTdpTurmaCodigo(turma.codigo, newPage).then((data) => {
        if (data) {
          if (data.error) {
            errorMessage(data.message);
          } else {
            setPresencas(data);
          }
        }
        setIsLoading(false);
      });
    }
  };

  const removePresencas = (codPresenca) => {
    setPresencas((prevState) => ({
      ...prevState,
      content: prevState.content.filter((ps) => ps.codigo !== codPresenca),
    }));
  };

  const handleDelete = (codigo) => {
    confirmAlert({
      title: "Alerta",
      message: "Deseja deletar esta presença?",
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            setIsLoadingRemove(true);
            remove(codigo).then((data) => {
              if (data) {
                if (data.error) {
                  errorMessage(data.message);
                } else {
                  removePresencas(codigo);
                  setPresenca(null);
                  toast.success("Registro excluído com Sucesso.", {
                    position: "bottom-left",
                  });
                }
              }
              setIsLoadingRemove(false);
            });
          },
        },
        {
          label: "Não",
          onClick: () => {},
        },
      ],
    });
  };

  return (
    <Container className={classes.paper} component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid>
          <Typography className={classes.title} variant="h6">
            Presença por Turma
          </Typography>
        </Grid>
        {turma ? (
          <>
            <Grid>
              <TurmaProfile turma={turma} handleTrocaTurma={handleTrocaTurma} />
            </Grid>
            <Grid>
              {isLoading ? (
                <Loading description="Carregando Presenças..." />
              ) : (
                <>
                  {presenca ? (
                    <PresencaTurmaForm
                      presenca={presenca}
                      setPresenca={setPresenca}
                      setPresencas={setPresencas}
                      turma={turma}
                    />
                  ) : (
                    <PresencaTurmaTable
                      presencas={presencas}
                      handleChangePage={handleChangePage}
                      isLoadingRemove={isLoadingRemove}
                      handleDelete={handleDelete}
                      setPresenca={setPresenca}
                    />
                  )}
                </>
              )}
            </Grid>
          </>
        ) : (
          <Grid>
            {isLoadingTurmas ? (
              <Loading description="Carregando Turmas..." />
            ) : (
              <TurmaTableSelectView
                turmas={turmas}
                onTurmaSelected={setTurma}
              />
            )}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};

export default PresencaTurmaContainer;
